"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { UserSessionsError, UserSessionsLoading, UserSessions as UserSessionsPresentational, } from "./lib/user-sessions";
import { useIsHydrated } from "./lib/use-is-hydrated";
import { ApiProvider, useApi, useSessions } from "./api";
import { useWorkOsApiUrl } from "./lib/widgets-context";
import { ErrorBoundary } from "./lib/error-boundary";
import { useQuery } from "@tanstack/react-query";
export const UserSessions = (props) => {
    const baseUrl = useWorkOsApiUrl();
    return (_jsx(ApiProvider, { widgetType: "user-sessions", authToken: props.authToken, baseUrl: baseUrl, children: _jsx(UserSessionsContent, { currentSessionId: "currentSessionId" in props ? props.currentSessionId : undefined }) }));
};
const UserSessionsContent = ({ currentSessionId, }) => {
    const isHydrated = useIsHydrated();
    const sessionsQuery = useSessions();
    const currentSessionIdQuery = useCurrentSessionIdQuery(currentSessionId);
    if (!isHydrated ||
        sessionsQuery.isLoading ||
        currentSessionIdQuery.isLoading) {
        return _jsx(UserSessionsLoading, {});
    }
    if (sessionsQuery.isError || currentSessionIdQuery.isError) {
        return (_jsx(UserSessionsError, { error: sessionsQuery.error || currentSessionIdQuery.error }));
    }
    return (_jsx(ErrorBoundary, { FallbackComponent: UserSessionsError, children: _jsx(UserSessionsPresentational, { sessionsData: sessionsQuery.data?.data || [], currentSessionId: currentSessionIdQuery.data ?? "" }) }));
};
function useCurrentSessionIdQuery(currentSessionId) {
    const { authToken } = useApi();
    return useQuery({
        queryKey: ["authToken"],
        queryFn: async () => {
            if (currentSessionId) {
                return currentSessionId;
            }
            const res = await Promise.resolve(authToken);
            const claims = getClaims(res);
            return claims.sid;
        },
    });
}
function getClaims(accessToken) {
    return JSON.parse(atob(accessToken.split(".")[1]));
}
//# sourceMappingURL=user-sessions.client.js.map